import React, { useState, useEffect } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { API } from '../../../API/API';
import Number from '../../../components/Number/Number';
import { useNavigate } from 'react-router-dom';
import ColEdit from '../../../components/ColEdit/ColEdit';

const SalaryReport = (props) => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [gridFilter, setGridFilter] = useState([]);

    const [columns] = useState([{
        name: 'Ажилтны нэр',
        fieldName: 'firstname',
        onRender: (item) => {
            return (
                <ColEdit onClick={() => onPressEmp(item.empid)}>{item.firstname}</ColEdit>
            );
        }
    }, {
        name: 'Эцэг/Эхийн нэр',
        fieldName: 'lastname'
    }, {
        name: 'Регистрийн дугаар',
        fieldName: 'regno'
    }, {
        name: 'Төлөв',
        fieldName: 'statusname'
    }, {
        name: 'Хуулийн этгээд',
        fieldName: 'companyname'
    }, {
        name: 'Дотоод нэгж',
        fieldName: 'depname'
    }, {
        name: 'Ажлын байр',
        fieldName: 'posname'
    },
    {
        name: 'Үндсэн цалин',
        fieldName: 'basewage',
        onRender: (item) => {
            return (
                <Number value={item.basewage} />
            );
        }
    },
    {
        name: 'Улсад ажилласан жил',
        fieldName: 'workedmonth'
    },
    {
        name: 'Имэйл',
        fieldName: 'email'
    },
    {
        name: 'Даатгуулагчийн төрөл',
        fieldName: 'insuretypename'
    },
    {
        name: 'Хүйс',
        fieldName: 'empgendername'
    }]);

    const [loading, setLoading] = useState(false);

    const getData = async (p_gridfilter) => {
        setLoading(true);
        let tData = [];

        let filtercolumns = [];
        if (p_gridfilter?.length > 0) {
            filtercolumns = p_gridfilter;
        }

        await API.post('/api/humanresource/report/get_employee_salary_report', filtercolumns).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });

        setData(tData);
        setOData(tData);
        setLoading(false);
    }

    const onPressEmp = (p_empid) => {
        if (p_empid) {
            navigate('/hrsuite/employee/' + p_empid);
        }
    }

    const getGridFilterData = async () => {
        let tGridFilter = [];
        await API.get('/api/humanresource/report/get_employee_salary_report_filter_data').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata?.length > 0) {
                    tGridFilter = response.data.retdata;
                }
            }
        });
        setGridFilter(tGridFilter);
    }

    useEffect(() => {
        getData();
        getGridFilterData();
    }, []);


    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onGridFilterChange = async (p_gridfiltervalue) => {
        getData(p_gridfiltervalue);
    }

    return (
        <div>
            <PageHeader
                title='Цалин'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                gridFilter={gridFilter}
                dataCount={data.length}
                onGridFilterChange={onGridFilterChange}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default SalaryReport;